import { render, staticRenderFns } from "./ZyroLogo.vue?vue&type=template&id=e041bd92&scoped=true&functional=true&"
import script from "./ZyroLogo.vue?vue&type=script&lang=js&"
export * from "./ZyroLogo.vue?vue&type=script&lang=js&"
import style0 from "./ZyroLogo.vue?vue&type=style&index=0&id=e041bd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "e041bd92",
  null
  
)

export default component.exports